import { render, staticRenderFns } from "./TenancyDeposit.vue?vue&type=template&id=cbbe0b32&scoped=true&"
import script from "./TenancyDeposit.vue?vue&type=script&lang=js&"
export * from "./TenancyDeposit.vue?vue&type=script&lang=js&"
import style0 from "./TenancyDeposit.vue?vue&type=style&index=0&id=cbbe0b32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbe0b32",
  null
  
)

export default component.exports